const initialiseInlineManual = () => {
  window.inlineManualOptions = { language: 'en' };

  const inlinemanualAppKey = "afa481733816977405b4bdb5834a1408";

  (function (e, n, a, t, i, r, s) {
    e[i] = e[i] || function () {
      (e[i].q = e[i].q || []).push(arguments)
    };
    e[i].l = 1 * new Date();
    e[i].snippet = { version: "2.0" };

    r = n.createElement(a);
    s = n.getElementsByTagName(a)[0];
    r.async = 1;
    r.src = `${t}${inlinemanualAppKey}.js`;
    r.id = `${t}-${i}`;
    s.parentNode.insertBefore(r, s);
  })(window, document, "script", "https://cdn.inlinemanual.com/inm/loader/loader.", "InlineManual");
};

export default initialiseInlineManual;